import { useSyncExternalStore } from 'react';
import { DEFAULT_LAYOUT, DIRECTIONAL_LAYOUT_FAMILIES, UNDIRECTED_LAYOUT_FAMILIES, LAYOUT_DIRECTIONS, } from '@orbit-mind/shared-types';
import { MAP_PALETTES } from '@orbit-mind/domain';
const defaults = { layout: DEFAULT_LAYOUT, palette: 'modern-light', grid: 'dots' };
let current = defaults;
let writes = Promise.resolve();
let persist = () => Promise.resolve();
const listeners = new Set();
const subscribe = (listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
export function getPreferences() {
    return current;
}
export function hydratePreferences(value) {
    try {
        const parsed = JSON.parse(value ?? '{}');
        if (typeof parsed !== 'object' || parsed === null)
            return;
        const layout = 'layout' in parsed ? parsed.layout : undefined;
        const palette = 'palette' in parsed ? parsed.palette : undefined;
        const grid = 'grid' in parsed ? parsed.grid : undefined;
        const layouts = [
            ...UNDIRECTED_LAYOUT_FAMILIES,
            ...DIRECTIONAL_LAYOUT_FAMILIES.flatMap((family) => LAYOUT_DIRECTIONS.map((direction) => `${family}/${direction}`)),
        ];
        current = {
            layout: typeof layout === 'string' && layouts.includes(layout)
                ? layout
                : DEFAULT_LAYOUT,
            palette: typeof palette === 'string' && MAP_PALETTES.some((p) => p.id === palette)
                ? palette
                : defaults.palette,
            grid: grid === 'lines' || grid === 'none' ? grid : 'dots',
            ...('touchSound' in parsed ? { touchSound: parsed.touchSound === true } : {}),
            ...('touchVibration' in parsed ? { touchVibration: parsed.touchVibration === true } : {}),
        };
        listeners.forEach((listener) => {
            listener();
        });
    }
    catch {
        /* Old or corrupt preferences never prevent opening existing maps. */
    }
}
export function configurePreferences(writer) {
    persist = writer;
}
export async function savePreferences(next) {
    const write = writes.then(async () => {
        await persist(JSON.stringify(next));
        current = next;
        listeners.forEach((listener) => {
            listener();
        });
    });
    writes = write.catch(() => undefined);
    await write;
}
export function usePreferences() {
    return useSyncExternalStore(subscribe, getPreferences, getPreferences);
}
//# sourceMappingURL=preferences.js.map